export default function HeroSection() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/029c3862f3c8658aa18362cdd85d72c8/9b80457a2197919f6102a40bc0b491e2.jpeg)',
          backgroundPosition: 'top center',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/10"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32 text-left">
        <div className="max-w-xl">
          <div className="mb-8">
            <p className="text-[#6EE7B7] text-lg font-semibold tracking-[0.3em] uppercase mb-3">
              OSAKA NORTH AREA
            </p>
            <div className="inline-block relative">
              <span className="block text-4xl md:text-5xl font-black text-white tracking-wide" style={{ fontFamily: "'Noto Serif JP', serif", textShadow: '0 2px 20px rgba(16,185,129,0.6)' }}>
                大阪市北部の訪問整体
              </span>
              <span className="block h-1 mt-3 bg-gradient-to-r from-[#10B981] to-[#6EE7B7] rounded-full"></span>
            </div>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight text-white" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            痛みの原因を追究し、短期間で解決
          </h1>

          <p className="text-xl md:text-2xl mb-4 text-white/95 font-medium">
            理学療法士の知識×整体の技術で、痛みの根本原因にアプローチ
          </p>

          <div className="mb-12 bg-white/10 backdrop-blur-md rounded-3xl p-8 border border-white/20">
            <p className="text-lg md:text-xl leading-relaxed text-white" style={{ lineHeight: '2.0' }}>
              大阪市北部、吹田市、豊中市、摂津市、守口市を中心に<br className="hidden md:block" />
              ご自宅で受けられる訪問整体です。<br />
              <br />
              通院が困難な方や外出が大変な方にも<br className="hidden md:block" />
              安心して整体を受けていただけます。
            </p>
          </div>

          <div className="flex flex-col gap-4 mb-8">
            <button
              onClick={scrollToContact}
              className="inline-flex items-center justify-center gap-3 px-12 py-5 bg-[#10B981] text-white text-xl font-bold rounded-full hover:bg-[#059669] transition-all duration-300 shadow-2xl hover:shadow-[0_20px_60px_rgba(16,185,129,0.5)] cursor-pointer whitespace-nowrap transform hover:scale-105"
            >
              <i className="ri-phone-line text-2xl"></i>
              <span>訪問整体のご相談はこちら</span>
              <i className="ri-arrow-right-line text-2xl"></i>
            </button>

            <a
              href="https://lin.ee/uGMpYkR"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 px-12 py-5 bg-[#06C755] text-white text-xl font-bold rounded-full hover:bg-[#05B04A] transition-all duration-300 shadow-2xl hover:shadow-[0_20px_60px_rgba(6,199,85,0.5)] cursor-pointer whitespace-nowrap transform hover:scale-105"
            >
              <i className="ri-line-fill text-2xl"></i>
              <span>LINEでお気軽にご相談ください</span>
              <i className="ri-arrow-right-line text-2xl"></i>
            </a>
          </div>

          <p className="text-sm text-white/80 text-center mb-8">
            お電話が難しい方は、公式LINEからもお気軽にご相談ください
          </p>

          <div className="flex flex-col gap-4 text-white/90">
            <div className="flex items-center gap-3">
              <i className="ri-map-pin-line text-2xl text-[#6EE7B7]"></i>
              <span className="text-base">大阪市北部・吹田市・豊中市・摂津市・守口市</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-phone-line text-2xl text-[#6EE7B7]"></i>
              <span className="text-base">090-1895-9421</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-time-line text-2xl text-[#6EE7B7]"></i>
              <span className="text-base">営業時間：10:00〜18:00（応相談）</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-calendar-close-line text-2xl text-[#6EE7B7]"></i>
              <span className="text-base">定休日：日曜日</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white/80 text-sm">Scroll</span>
          <i className="ri-arrow-down-line text-2xl text-white/80"></i>
        </div>
      </div>
    </section>
  );
}